import { IResource } from "../i18n";

// tslint:disable-next-line: variable-name
const translation_pl: IResource = {
    feedback_button_text: "Wyślij",
    feedback_cta_0_3: "Naprawdę nam przykro, proszę nam powiedzieć, co powinniśmy naprawić",
    feedback_cta_4_6: "To pech, powiesz nam, co mamy poprawić?",
    feedback_cta_7_8: "Co możemy zrobić, żeby było lepiej?",
    feedback_cta_9_10: "Fantastycznie! Możesz nam powiedzieć jedną rzecz, którą najbardziej ci się podobała?",
    feedback_mail_subject: "Opinia na temat aplikacji Meet",
    feedback_text_legend: "Jesteśmy równie wdzięczni za negatywną i pozytywną informację zwrotną.",
    feedback_text_title: "Przekaż swoją opinię tutaj (opcjonalnie)",
    feedback_title_finished: "Twój Meet dobiegł końca",
    feedback_title_ongoing: "Proszę, pomóż nam usprawnić Meet",
    feedback_title_question: "Jak prawdopodobne jest, że polecisz Meet przyjacielowi lub koledze?",
    feedback_value_best: "Bardzo prawdopodobne",
    feedback_value_worst: "Mało prawdopodobne",

    onboarding_button_jointext: "Dołącz do Meet",
    onboarding_description_four: "Guzik.",
    onboarding_description_one: "Jako pierwszy użytkownik, możesz dostosować sposób, w jaki inni będą cię widzieć w tym Meet'cie.",
    onboarding_description_three: "DOŁĄCZ DO MEET",
    onboarding_description_two: "Kiedy już będziesz gotowy, po prostu kliknij ",
    onboarding_label_color: "Kolor",
    onboarding_label_consentAgree: "Zgadzam się z Meet",
    onboarding_label_consentPrivacy: "Polityka prywatności",
    onboarding_label_consentAnd: "oraz",
    onboarding_label_consentTermsOfUse: "Regulamin",
    onboarding_label_darkTheme: "Tryb ciemny",
    onboarding_label_firstName: "Twoje imię i nazwisko (opcjonalnie)",
    onboarding_label_green: "Zielony",
    onboarding_label_indigo: "Indygo",
    onboarding_label_lastName: "Twoje nazwisko (opcjonalnie)",
    onboarding_label_lightTheme: "Temat światła",
    onboarding_label_orange: "Pomarańczowy",
    onboarding_label_pink: "Różowy",
    onboarding_label_purple: "Fioletowy",
    onboarding_label_teal: "Niebieski",
    onboarding_label_theme: "Temat",
    onboarding_label_yellow: "Żółty",
    onboarding_title: "Nice to Meet you!",

    invite_legend_text: "Wyślij ten link do osoby, którą chcesz na rozmowę.",
    invite_link_copy: "Link do kopiowania",
    invite_link_defaultCopied: "Link skopiowany do schowka!",
    invite_link_email: "Wyślij zaproszenie na e-mail",
    invite_link_label: "Twój url z zaproszenieml",
    invite_link_sms: "Zaproszenie SMS-owe",
    invite_mail_body: "Witam, proszę dołączyć do mojego Meet.",
    invite_mail_signature: "Pozdrawiam",
    invite_mail_subject: "Link do sprzężenia Meet",
    invite_title_text: "ZAPROSIĆ KOGOŚ DO SWOJEGO MEET",

    citypicker_label: "Miasto",
    citypicker_nomatch: "Brak pasujących lokalizacji",

    userprofile_city_label: "Miasto",
    userprofile_color_label: "Kolor",
    userprofile_email_label: "Adres e-mail",
    userprofile_label_green: "Zielony",
    userprofile_label_indigo: "Indygo",
    userprofile_label_orange: "Pomarańczowy",
    userprofile_label_pink: "Różowy",
    userprofile_label_purple: "Fioletowy",
    userprofile_label_teal: "Niebieski",
    userprofile_label_yellow: "Żółty",
    userprofile_locale_label: "Język",
    userprofile_name_label: "Imię",
    userprofile_surname_label: "Nazwisko",
    userprofile_theme_label: "Temat",
    userprofile_themedark_label: "Ciemny temat",
    userprofile_themelight_label: "Temat światła",

    options_tab_profile: "Profil",

    consentdialog_button_cancel: "Anuluj",
    consentdialog_button_ok: "OK",

    layout_meet_end: "ZAKOŃCZ",
    layout_meet_leave: "Opuść Meet",

    layout_sidebar_labelClose: "Zamknij menu z paskiem bocznym",
    layout_sidebar_labelOpen: "Otwórz menu paska bocznego",
    layout_sidebar_labelTitle: "Otwórz menu paska bocznego",
    layout_title_text: "Meet | Spotkania bez napięcia",

    layout_toolbar_enter: "Wprowadź pełny ekran",
    layout_toolbar_invite: "Zaproś",
    layout_toolbar_invite_tooltip: "Zaproś innych ludzi na ten Meet",
    layout_toolbar_leave: "Opuszczenie pełnego ekranu",

    layout_dialog_descriptionEnd: "To zakończy Meet dla wszystkich uczestników",
    layout_dialog_titleEnd: "Jesteś pewna, że chcesz zakończyć ten Meet?",
    layout_dialog_titleLeave: "Jesteś pewien, że chcesz opuścić ten Meet?",

    layout_dialog_descriptionLeave: "To nie zakończy Meet dla innych uczestników",
    layout_sidebar_explorer: "Pomoc",
    layout_sidebar_feedback: "Udostępnianie informacji zwrotnych",
    layout_sidebar_settings: "Ustawienia",

    layout_finish_endmeet: "Zakończyć bieżące spotkanie",
    layout_finish_leavemeet: "Opuścić bieżące spotkanie",

    layout_cta_register: "Potrzebujesz 60 minut darmowego Meeta?",
    layout_cta_register_tooltip: "Zapisz się na bezpłatny kredyt 10$",

    layout_dialog_descriptionAbandon: "Wygląda na to, że tylko ty jesteś na zawołanie",
    layout_dialog_titleAbandon: "Chcesz zakończyć ten Meet?",

    language_en_title: "English",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_es_title: "Español",
    language_de_title: "Deutsche",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    meeting_finished_title: "MEET ZAKOŃCZONY",
    meeting_finished_tooltip: "Dostęp tylko do odczytu",

    layout_reactivate_button: "Reaktywuj Meet",
    layout_reactivate_tooltip: "Kliknij tutaj, jeśli chcesz ponownie otworzyć i użyć tego zakończonego Meetu",
    layout_dialog_titleReactivate: "Jesteś pewien, że chcesz reaktywować ten Meet?",
    layout_dialog_descriptionReactivate: "Dzięki temu Meet zostanie ponownie otwarty do dołączenia, edycji i innych modyfikacji.",

    toast_reconnecting_title: "Problem z sygnalizacją telefoniczną",
    toast_reconnecting_message: "Połączenie (state:{state}) utracone z powodu błędu {error}. Ponowne połączenie...",
    toast_reconnected_title: "Wywołanie sygnalizacji",
    toast_reconnected_message: "Połączenie przywrócone. Państwa: {state}",
    toast_disconnected_title: "Wywołanie błędu sygnalizacyjnego",
    toast_disconnected_message: "{state}) zamknięty z powodu błędu {error}. Spróbuj odświeżyć tę stronę, aby ponownie uruchomić połączenie.",

    config_title_text: "Utwórz nowe spotkanie",
    config_title_ctaOne: "Zdefiniuj elementy nowego spotkania, które chcesz utworzyć.",
    config_title_ctaTwo: "Wszystkie dane wejściowe są opcjonalne i można je pominąć.",
    config_title_label: "Tytuł",
    config_description_label: "Opis",
    config_duration_label: "Czas trwania",
    config_tool_label: "Poznaj narzędzia",
    config_tool_call: "Poznaj połączenie wideo",
    config_tool_editor: "Edytor kodu",
    config_tool_whiteboard: "Tablica",
    config_passcode_label: "Poznaj kod dostępu (jeśli istnieje)",

    search_placeholder_text: "Wprowadź kryteria wyszukiwania",
    createMeeting_button_create: "Stwórz Meet",

    projectboard_scheduleinfo_none: "Meet nie ma zdefiniowanej daty rozpoczęcia, więc może być wykorzystany w dowolnym momencie.",
    projectboard_scheduleinfo_anytime: "w każdej chwili",

    projectboard_join_anyone: "Każdy, kto ma link, może dołączyć do",
    projectboard_role_guest: "Gość",
    projectboard_role_interviewee: "Kandydatka",
    projectboard_role_interviewer: "Ankieter",
    projectboard_role_organizer: "Organizator",

    projectboard_status_draft: "W projekcie",
    projectboard_status_scheduling: "Planowanie",
    projectboard_status_schedulingFailed: "Planowanie nie powiodło się",
    projectboard_status_pending: "W oczekiwaniu na",
    projectboard_status_ready: "Gotowy",
    projectboard_status_starting: "Począwszy od",
    projectboard_status_inprogress: "W toku",
    projectboard_status_onhold: "Na wstrzymanie",
    projectboard_status_completed: "Ukończono",
    projectboard_status_canceled: "Odwołano",
    projectboard_status_archived: "Archiwizowany",
    projectboard_status_feedbackWait: "Czekanie na informację zwrotną",
    projectboard_status_feedbackDone: "Zebrane informacje zwrotne",
    projectboard_status_feedbackFail: "Zbieranie informacji zwrotnych nie powiodło się",

    projectboard_status_stopped: "Zatrzymany",

    minibar_dashboard_title: "Panel",
            
    layout_sidebar_rateus: "Oceń nas",

    invite_passcode_label: "Kod",

    invite_text_copy: "Kopiuj zaproszenie",

    invite_text_body: "Proszę dołączyć do mojego Meet at {url}",
    
    invite_passcode_body: "Dołącz do mojego Meet at {url} i użyj kodu dostępu {passcode}",

    invite_text_copied: "Tekst zaproszenia meet jest kopiowany do schowka.",
    
    invite_pascode_add: "Dodawanie kodu dostępu do adresu URL",

    participant_join_message: "{participant} dołączył do spotkania.",
    participant_left_message: "{participant} opuścił spotkanie.",
            
    minibar_dashboard_tooltip: "Zarządzanie wywiadami",

    layout_sidebar_snapshot: "Migawka",

    snapshots_none_text: "Zrób jedną lub więcej migawek edytora kodu i tablicy i przejrzyj je po Meet.",
    snapshot_toast_text: "Zdjęcie zrobione",
    snapshots_cta_text: "Zrób migawkę (F9)",
    snapshot_sentiment_positive: "Pozytywna migawka",
    snapshot_sentiment_negative: "Negatywna migawka",
    snapshot_sentiment_note: "Uwaga",
    
    snapshot_personal_value: "Migawka osobista",
    snapshot_personal_title: "Widoczne tylko dla Ciebie",
    snapshot_team_value: "Migawka zespołu",
    snapshot_team_title: "Widoczne tylko dla twojego zespołu.",
    snapshot_public_title: "Widoczny dla wszystkich uczestników",
    snapshot_public_value: "Migawka publiczna",

    snapshots_live_text: "Wróć do wywiadu na żywo",
    
    snapshot_action_delete: "Usuń",
    snapshot_action_load: "Migawka obciążenia",
    
    snapshot_delete_dialog_title: "Usuń migawkę?",
    snapshot_delete_dialog_description: "Potwierdź, że chcesz usunąć tę migawkę",
    snapshots_final_back: "Wróć do stanu końcowego Meet",
};

export default translation_pl;
